export enum SkywardItemColor {
    INITIAL = 'initial',
    LOW_MULTIPLIER = 'lowMultiplier',
    MEDIUM_MULTIPLIER = 'mediumMultiplier',
    HIGH_MULTIPLIER = 'highMultiplier',
    FLEW_AWAY = 'flewAway',
}
